import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const ModuleContext = createContext();
const MODULE_KEY = 'gl.activeModule';

// Valid module ids: '' (picker), 'custody', 'gold', 'loans', 'receipts', 'gold_purchase', 'kassa', 'kassa2', 'safe'
export function ModuleProvider({ children }) {
  const [activeModule, setActiveModuleState] = useState('');
  // Optional one-shot payload passed when switching modules (e.g. a receipt
  // prefill from Custody). Consumed by the target module, then cleared.
  const [moduleParams, setModuleParams] = useState(null);

  useEffect(() => {
    const saved = localStorage.getItem(MODULE_KEY);
    if (saved) setActiveModuleState(saved);
  }, []);

  useEffect(() => {
    localStorage.setItem(MODULE_KEY, activeModule || '');
  }, [activeModule]);

  const value = useMemo(() => ({
    activeModule,
    moduleParams,
    setActiveModule: (id, params = null) => { setModuleParams(params); setActiveModuleState(id); },
    clearModuleParams: () => setModuleParams(null),
    goToPicker: () => { setModuleParams(null); setActiveModuleState(''); },
  }), [activeModule, moduleParams]);

  return <ModuleContext.Provider value={value}>{children}</ModuleContext.Provider>;
}

export function useModule() {
  const ctx = useContext(ModuleContext);
  if (!ctx) throw new Error('useModule must be used within a ModuleProvider');
  return ctx;
}
